













import { Component, Watch, Mixins } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import MatrixCameraMixin from "./MatrixCameraMixin";	
import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
import { AreaNode } from "@/types/groups/AreaNode";
import { DeviceNode } from "@/types/devices/DeviceNode";
import { AreaTreeNodeType } from '@/types/area-tree/AreaTreeNodeType';
import { AreaContentConfiguration } from '@/types/area-tree/AreaContentConfiguration';
import { devicesApi } from '@/services/api.devices.service';
import { cameras } from "@/utils/area-tree/configurations";
import { EventRegion, SiteMonitorState } from "@/store/site-monitor/types";

const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"area-tree-picker": AreaTreePicker
	},
})
export default class AreaList extends Mixins(MatrixCameraMixin) {
	@Getter private getFeature: (featureName: string[]) => boolean;

	@SiteMonitor.State((state: SiteMonitorState) => state.eventRegion) private eventRegion: EventRegion;

	private selectedTreeItem: AreaNode | DeviceNode = null;

	private async mounted() {
		if (this.eventDetails) {
			this.selectNodeInTreeBasedOnGroupID(this.eventDetails.groupID);
		}
	}

	@Watch("eventId")
	private onEventIdChanged() {
		if (this.eventDetails) {
			this.selectNodeInTreeBasedOnGroupID(this.eventDetails.groupID);
		}
	}

	private selectNodeInTreeBasedOnGroupID(groupId: number) {
		// Create a new AreaNode with the groupId in order to select it in the tree
		const areaNode: AreaNode = {
			id: groupId,
			groupTypeId: 4,
			address: "",
			latLong: "",
			children: [],
			label: ""
		}

		this.selectedTreeItem = areaNode;
	}

	/**
	 * Handler for when the user selects an item in the area tree. Possible nodes include groups and cameras.
	 */
	private onTreeItemSelected(treeItem: AreaNode | DeviceNode) {	
		this.selectedTreeItem = treeItem;

		switch (treeItem.nodeType) {
			case AreaTreeNodeType.Group: {
				// Don't do anything yet with a selected groupID
				break;
			}
			case AreaTreeNodeType.Camera: {
				const camera = { deviceID: (treeItem as DeviceNode).deviceId, title: (treeItem as DeviceNode).label }
				this.showAreaCamera(camera);
				break;
			}
			default: {
				console.error("MediaMatrix:AreaSelect - Unknown item type selected in tree.");
			}
		}
	}

	private showAreaCamera(camera: any) {
		if (this.isController) {
			this.setAwaitingCamera({
				objectID: camera.deviceID,
				itemType: 1,
				title: camera.title,
			});
		}
	}	

	private get isSearchTermsInAnyOrderEnabled() {
		return this.getFeature(["Views", "SearchTermsInAnyOrder"]);
	}

	/**
	 * Gets the content configuration to use for the area tree. Sets up cameras to be displayed for groups, and
	 * ensures the search term order feature is passed through.
	 */
	private get treeContentConfiguration(): AreaContentConfiguration[] {
		return [
			{
				...cameras,
				onSearch: async (query, regionUrl) =>
					await devicesApi.searchDevicesForGroupTree(
						query,
						[1],
						this.isSearchTermsInAnyOrderEnabled,
						regionUrl
					)
			}
		];
	}
}
